import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, FormGroup, Label, Input, Row, Col, FormFeedback } from 'reactstrap';
import Select from 'react-select';
import UploadMedia from '../../../components/common/UploadMedia/UploadMedia';

const OpenNewTicket = () => {

    const [pictures, setPictures] = useState([])


    // Define the validation schema using Yup
    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .min(3, 'First Name must be at least 3 characters')
            .max(30, 'First Name must be at most 30 characters')
            .required('First Name is required'),
        fullName: Yup.string()
            .min(3, 'Full Name must be at least 3 characters')
            .max(50, 'Full Name must be at most 50 characters')
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email format')
            .required('Email is required'),
        phoneNumber: Yup.string()
            .matches(/^\d{10}$/, 'Phone number must be 10 digits')
            .required('Phone Number is required'),
        category: Yup.object().required('Category is required'),
        description: Yup.string().required('Description is required'),
    });

    // Initialize the form with React Hook Form and Yup resolver
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    // Form submission handler
    const onSubmit = (data) => {
        console.log(data);
        // Handle form submission logic here
    };

    const categoryOptions = [
        { value: 'Order issue', label: 'Order issue' },
        { value: 'Product Inquiry', label: 'Product Inquiry' },
        { value: 'Technical Support', label: 'Technical Support' },
        { value: 'Other', label: 'Other' },
    ];

    return (
        <div>
            <div style={{ padding: '1rem', backgroundColor: '#F2F2F2', borderRadius: '6px' }}>
                If you're experiencing issues or have questions, we're here to help. Please fill out the
                form below to open a new support ticket. Our team will get back to you as soon as
                possible.
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: '1rem' }}>
                <Row>
                    <Col xl='6' lg='6' md='12' sm='12' xs='12'>
                        <FormGroup>
                            <Label for="firstName">First Name</Label>
                            <Controller
                                name="firstName"
                                control={control}
                                render={({ field }) => (
                                    <Input {...field} type="text" placeholder='First Name' id="firstName" invalid={errors.firstName ? true : false} />
                                )}
                            />
                            {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Label for="fullName">Full Name</Label>
                            <Controller
                                name="fullName"
                                control={control}
                                render={({ field }) => (
                                    <Input {...field} type="text" placeholder='Last Name' id="fullName" invalid={errors.fullName ? true : false} />
                                )}
                            />
                            {errors.fullName && <FormFeedback>{errors.fullName.message}</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Label for="email">Email</Label>
                            <Controller
                                name="email"
                                control={control}
                                render={({ field }) => (
                                    <Input {...field} type="email" placeholder='Email' id="email" invalid={errors.email ? true : false} />
                                )}
                            />
                            {errors.email && <FormFeedback>{errors.email.message}</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Label for="phoneNumber">Phone Number</Label>
                            <Controller
                                name="phoneNumber"
                                control={control}
                                render={({ field }) => (
                                    <Input {...field} type="number" placeholder='Phone Number' id="phoneNumber" invalid={errors.phoneNumber ? true : false} />
                                )}
                            />
                            {errors.phoneNumber && <FormFeedback>{errors.phoneNumber.message}</FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Label for="category">Category</Label>
                            <Controller
                                name="category"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        options={categoryOptions}
                                        onChange={(selectedOption) => field.onChange(selectedOption)} // Handle onChange
                                        isClearable
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                borderColor: errors.category ? 'red' : provided.borderColor,
                                            }),
                                        }}
                                    />
                                )}
                            />
                            {errors.category && <FormFeedback>{errors.category.message}</FormFeedback>}
                        </FormGroup>
                    </Col>
                    <Col xl='6' lg='6' md='12' sm='12' xs='12'>
                        <FormGroup>
                            <Label for="description">Issue Description</Label>
                            <Controller
                                name="description"
                                control={control}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        type="textarea"
                                        id="description"
                                        placeholder='Details'
                                        style={{ height: '100%', minHeight: '150px' }}
                                        invalid={errors.description ? true : false}
                                    />
                                )}
                            />
                            {errors.description && <FormFeedback>{errors.description.message}</FormFeedback>}
                        </FormGroup>
                        <div>
                            <div className='fw-medium'>Upload Images</div>
                            <UploadMedia allowImages={true} allowVideos={false} maxMedia={3} pictures={pictures} setPictures={setPictures} />
                        </div>
                    </Col>
                    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                        <div className="d-flex justify-content-end" style={{ marginTop: '1.5rem' }}>
                            <button type="submit" className='btn ' style={{ backgroundColor: '#41B8E4', color: '#fff' }}>
                                Submit Ticket
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default OpenNewTicket;
